import { useCoins } from "@contexts/CoinsContext"
import { resolveImageUrl } from "@helpers/image.helper";

type Props = {
    amount: number,
    coinId?: string
    size?: "md" | "sm"
}

export function CoinBadgeV2({ amount, coinId, size = 'md' }: Props) {
    const { getCoin, coins } = useCoins()

    const coin = getCoin(coinId ?? "")
    console.log(coins, coinId)

    return <div
        className={`group inline-flex items-center rounded-lg border text-white bg-jacarta-800 border-jacarta-500 ${size === "sm" ? "px-3 py-2" : "px-4 py-3"}`}>
        <img src={resolveImageUrl(coin?.icon ?? "/src/img/coins/gold.svg")} className={`${size === "sm" ? "mr-1 h-3 w-3" : "mr-2 h-4 w-4"} fill-jacarta-700 group-hover:fill-white dark:fill-white`} alt="" />
        <span className={`${size === "sm" ? "text-xs" : "text-2xs"} font-medium`}>{(amount / Math.pow(10, coin?.decimals ?? 6)).toLocaleString()} {coin?.name}</span>
    </div>
}